<template>
  <div>
    <div class="menu">
      <div class="logo">
        <LogoIcon />
        <span>ARTISTHUB</span>
      </div>
      <div class="menu-items">
        <div class="menu-left">
          <div class="menu-item" v-for="(menu, index) in leftMenu" :key="index">
            <router-link :to="menu.routeName">
              <span>{{ menu.linkName }}</span>
            </router-link>
          </div>
        </div>
        <div class="menu-right">
          <div class="menu-item">
            <a href="http://help.artisthub.io/"><span>Help</span></a>
          </div>
          <div
            class="menu-item"
            v-for="(menu, index) in rightMenu"
            :key="index"
          >
            <router-link :class="menu.class" :to="{ name: menu.routeName }">
              <span>{{ menu.linkName }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="categories">
        <div
          class="category"
          v-for="(current, index) in categories"
          :key="index"
          :class="{ active: current.slug === category.slug }"
          @click="category = current"
        >
          <div class="name">{{ current.name }}</div>
        </div>
      </div>
      <div class="search">
        <i class="fal fa-search"></i>
        <input
          type="text"
          placeholder="Search posts..."
          v-model="searchQuery"
        />
      </div>
    </div>
    <div class="category-title">
      {{ category.name }}
    </div>
    <template v-if="!$apolloData.queries.blog_posts.loading">
      <div class="posts" v-if="posts.length">
        <div class="post" v-for="(post, index) in posts" :key="index">
          <router-link
            :to="{ name: 'BlogPost', params: { slug: post.slug } }"
            tag="div"
          >
            <div class="go-to-post">
              <i class="fal fa-external-link"></i>
            </div>
            <div class="top">
              <div class="category">
                {{ post.category && post.category.name }}
              </div>
              <div class="date">{{ post.created_at | formatDate }}</div>
            </div>
            <div class="title">{{ post.title }}</div>
            <div class="description">{{ post.description }}</div>
          </router-link>
        </div>
      </div>
      <div class="no-posts" v-else>
        No Posts Found
      </div>
    </template>
    <div class="loading" v-else>
      Loading...
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { GET_POSTS, GET_CATEGORIES } from "@/graphql";
import LogoIcon from "@/components/AppLogo";

export default {
  components: {
    LogoIcon
  },
  data() {
    return {
      posts: {},
      searchQuery: "",
      category: {
        name: "All Posts",
        slug: ""
      },
      categories: [],
      leftMenu: [
        {
          routeName: "#pricing",
          linkName: "Pricing"
        }
      ],
      rightMenu: [
        {
          routeName: "Login",
          class: "",
          linkName: "Log In"
        },
        {
          routeName: "Signup",
          class: "button-default big",
          linkName: "Sign Up"
        }
      ]
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("MMM. Do, YYYY");
    }
  },
  computed: {
    postFilters() {
      if (!this.category.slug && this.searchQuery.length < 3) return {};

      let filters = {};
      if (this.searchQuery.length >= 3) {
        filters._or = [
          {
            title: {
              _ilike: `%${this.searchQuery}%`
            }
          },
          {
            description: {
              _ilike: `%${this.searchQuery}%`
            }
          },
          {
            content: {
              _ilike: `%${this.searchQuery}%`
            }
          },
          {
            category: {
              name: {
                _ilike: `%${this.searchQuery}%`
              }
            }
          },
          {
            category: {
              slug: {
                _ilike: `%${this.searchQuery}%`
              }
            }
          }
        ];
      }

      if (this.category.slug) {
        filters.category = {
          slug: {
            _eq: this.category.slug
          }
        };
      }

      return { filters };
    }
  },
  apollo: {
    blog_posts: {
      client: "httpClient",
      query: GET_POSTS,
      variables() {
        return this.postFilters;
      },
      result({ data }) {
        this.posts = data.blog_posts;
      }
    },
    blog_categories: {
      client: "httpClient",
      query: GET_CATEGORIES,
      variables() {
        return {};
      },
      result({ data }) {
        this.categories = [
          {
            name: "All Posts",
            slug: ""
          },
          ...data.blog_categories
        ];
      }
    }
  }
};
</script>

<style lang="scss">
.menu {
  padding: 30px;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  z-index: 1;

  .logo {
    display: flex;
    align-items: center;
    img {
      width: 33px;
      path {
        fill: white;
      }

      display: none;
    }
    span {
      margin-left: 13px;
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 21px;
      line-height: 39px;
      text-transform: uppercase;
      color: white;
    }
  }
  .menu-items {
    margin-left: 60px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 60px;
  }
  .menu-left,
  .menu-right {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 40px;
    align-items: center;
    .menu-item {
      display: flex;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: white;
      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }
}
.nav {
  display: flex;
  padding: 10px 35px 0;
  align-items: center;
  justify-content: space-between;
  .categories {
    display: flex;
    gap: 10px;
    // each category is just text with font change and underline on hover and cursor pointer
    .category {
      cursor: pointer;
      margin-right: 10px;
      border-bottom: 1px solid transparent;
      .name {
        font-weight: 600;
        font-size: 16px;
        line-height: 27px;
        color: $text-type-0;
        margin-bottom: 10px;
      }
      &:hover,
      &.active {
        border-bottom-color: $text-type-2;
        .name {
          color: $text-type-2;
        }
      }
    }
  }
  .search {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 14px;
    border: 1px solid $text-type-0;
    border-radius: 10px;
    i {
      color: $text-type-0;
      font-size: 20px;
    }
    input {
      border: none;
      outline: none;
      background: transparent;
      color: $text-type-0;
      font-size: 16px;
      line-height: 24px;
      &::placeholder {
        color: $text-type-0;
      }
    }
  }
}
.category-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  color: $text-type-2;
  margin: 40px 30px 20px;
}
.posts {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  padding: 30px;
  .post {
    width: calc(50% - 5px);
    cursor: pointer;
    padding: 20px;
    border: 1px solid $text-type-0;
    border-radius: 10px;
    overflow: hidden;
    margin: 10px 0;
    &:hover {
      border: 1px solid #ffffff;
    }
    .go-to-post {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      &:hover {
        i {
          color: $text-type-1;
        }
      }
      i {
        color: $text-type-0;
        font-size: 20px;
      }
    }
    .top {
      display: flex;
      margin-bottom: 10px;
      .category {
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: $text-type-1;
        margin-right: 10px;
      }
      .date {
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: $text-type-0;
      }
    }
    .title {
      font-weight: 600;
      font-size: 24px;
      line-height: 27px;
      color: $text-type-2;
      margin-bottom: 10px;
    }
    .description {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: $text-type-0;
    }
  }
}
.loading,
.no-posts {
  margin: 40px 30px;
  font-size: 30px;
  font-weight: 600;
  color: $text-type-0;
}
</style>
